import React from 'react';

import { BuilderControls } from '../layout/Builder.jsx';
import Layout from './Layout.jsx';
import Token from './Token.jsx';
import Utilities from './Utilities.jsx';

function Tab(props) {
    let className = 'tab__link';
    if (props.className) {
        className += ` ${props.className}`;
    }
    if (props.active) {
        className += ' current';
    }
    let handleClick;
    if (props.onClick) {
        handleClick = () => props.onClick(props.value);
    }
    return (
        <li className={className} style={props.style} value={props.id} onClick={handleClick}>
            <span>{props.display || props.id}</span>
        </li>
    );
}

function TabV2(props) {
    if (props.visible == false) {
        return null;
    }
    if (!props.design) {
        return <Tab {...props} />
    }
    let content = Token.parseTokenizedString(props.design, () => props.display);
    if (props.active && props.activeColor) {
        content = Utilities.injectStyleIntoString(content, `color:${props.activeColor};`);
    }
    if (props.alignment) {
        content = Utilities.injectStyleIntoString(content, `text-align:${props.alignment};`);
    }
    if (props.styleSeparator) {
        content += `<span class="tab__link--separator" style="${props.styleSeparator}" />`
    }
    return (
        <li className="tab__link tab__link2 richText"
            dangerouslySetInnerHTML={{ __html: content }}
            style={props.style}
            value={props.value}
            onClick={() => props.onClick(props.value)} />
    )
}

function TabsContainer(props) {
    let className = 'tabs__controls';
    if (props.className) {
        className += ` ${props.className}`;
    }
    if (props.design) {
        className += ' tabs__controls2'
    }
    const style = { justifyContent: props.alignment };
    let separatorOffset;
    if (props.spacing) {
        style.columnGap = `${props.spacing}px`;
        separatorOffset = `-${props.spacing / 2}px`
    }
    Utilities.copyObject(props.style, style);
    if (props.builder) {
        style.pointerEvents = 'none';
        style.zIndex = 1;
    }
    let tabOptions;
    if (props.tabs) {
        if (props.tabComponent) {
            tabOptions = [];
            let tab;
            props.tabs.forEach((d, i) => {
                tab = d;
                if (d.tab) {
                    tab = d.tab;
                }
                const style = {};
                Utilities.copyObject(props.styleTab, style);
                if (!props.design) {
                    if (props.tab == tab.id) {
                        if (props.activeTabColor) {
                            style.color = props.activeTabColor;
                        } else if (props.config && props.config.colors) {
                            style.color = props.config.colors.bodyText;
                        }
                    } else if (!style.color && props.config && props.config.colors) {
                        style.color = props.config.colors.accent;
                    }
                }
                let _styleSeparator = props.styleSeparator;
                if (i == props.tabs.length - 1) {
                    style.borderRightStyle = 'none';
                    style.marginRight = '0';
                    style.paddingRight = '0';
                    _styleSeparator = undefined;
                } else {
                    _styleSeparator += `right:${separatorOffset};`;
                }
                const display = tab.display || `Tab ${i + 1}`;
                tabOptions.push(
                    <props.tabComponent
                        key={tab.id}
                        active={props.tab == tab.id}
                        activeColor={props.activeTabColor}
                        alignment={props.alignment}
                        anchorName={tab.anchorName}
                        design={props.design}
                        display={display}
                        styleSeparator={_styleSeparator}
                        style={style}
                        value={tab}
                        visible={d.visible}
                        onClick={props.onTabClick} />
                );
            })
        } else {
            tabOptions = props.tabs.map((d) => <Tab key={d.id} active={props.tab == d.id} display={d.display} value={d.id} onClick={props.onTabClick} />)
        }
    }
    return (
        <ul className={className} style={style}>
            {tabOptions}
            {props.children}
        </ul>
    );
}

function TabSelectionDropDown(props) {
    const label = props.label ? `${props.label}:` : 'VIEW TAB:';
    return (
        <BuilderControls label={label} onBlockMove={props.onBlockMove}>
            {
                props.disabled == true &&
                <span>--</span>
            }
            {
                !props.disabled &&
                <select value={props.tab} onChange={(event) => props.onSelect(event.currentTarget.value)}>
                    {props.children}
                </select>
            }
        </BuilderControls>
    );
}

// #region LAYOUT TABS

function LayoutTabs(props) {
    React.useEffect(() => {
        if (!props.builder) {
            return;
        }
        const includes = props.includes || {};
        if ((props.tab == Layout.Type.Result.Slideshow && !includes[Layout.Type.Result.Slideshow]) ||
            (props.tab == Layout.Type.Result.Thumbnails && !includes[Layout.Type.Result.Thumbnails]) ||
            (props.tab == Layout.Type.Result.Pinterest && !includes[Layout.Type.Result.Pinterest]) ||
            (props.tab == Layout.Type.Result.HorizontalMasonry && !includes[Layout.Type.Result.HorizontalMasonry]) ||
            (props.tab == Layout.Type.Result.List && !includes[Layout.Type.Result.List])) {
            // Active tab is no longer visible => Determine new tab to select (default to Thumbnails when possible)
            let tab = Layout.Type.Result.Thumbnails;
            if (!includes[Layout.Type.Result.Thumbnails]) {
                // Thumbnails tab not visible => Determine the first visible tab in the list
                if (includes[Layout.Type.Result.Slideshow]) {
                    tab = Layout.Type.Result.Slideshow;
                } else if (includes[Layout.Type.Result.Pinterest]) {
                    tab = Layout.Type.Result.Pinterest;
                } else if (includes[Layout.Type.Result.HorizontalMasonry]) {
                    tab = Layout.Type.Result.HorizontalMasonry;
                } else if (includes[Layout.Type.Result.List]) {
                    tab = Layout.Type.Result.List;
                }
            }
            props.onTabClick(tab);
        }
    }, [
        props.includes[Layout.Type.Result.Slideshow],
        props.includes[Layout.Type.Result.Thumbnails],
        props.includes[Layout.Type.Result.Pinterest],
        props.includes[Layout.Type.Result.HorizontalMasonry],
        props.includes[Layout.Type.Result.List]
    ]);

    if (!props.tabs || props.tabs.length <= 1) {
        return null;
    }
    return <TabsContainer {...props} />
}

function LayoutTabSelectionDropDown(props) {
    if (!props.tabs) {
        return null;
    }
    return (
        <TabSelectionDropDown tab={props.tab} onBlockMove={props.onBlockMove} onSelect={props.onSelect}>
            {props.tabs.map((d) => <option key={d.id} value={d.id}>{d.id}</option>)}
        </TabSelectionDropDown>
    );
}

function withLayoutTabOptions(WrappedComponent) {
    return function (props) {
        const [tab, setTab] = React.useState(undefined);
        const handleTabClick = (tab) => {
            let tabId = tab;
            if (tab && tab.id) {
                setTab(tab.id);
                tabId = tab.id;
            } else {
                setTab(tab);
            }
            if (props.onLayoutContainerTabSelection) {
                props.onLayoutContainerTabSelection(tabId);
            }
        }
        const isValidId = (id) => {
            switch (id) {
                case Layout.Type.Result.HorizontalMasonry:
                case Layout.Type.Result.List:
                case Layout.Type.Result.Pinterest:
                case Layout.Type.Result.Slideshow:
                case Layout.Type.Result.Thumbnails:
                    return true;
                default:
                    return false;
            }
        }
        React.useEffect(() => {
            if (props.active && isValidId(props.layoutContainerTabId)) {
                setTab(props.layoutContainerTabId);
            }
        }, []);
        React.useEffect(() => {
            if (props.active && props.onLayoutContainerTabSelection) {
                props.onLayoutContainerTabSelection(props.layoutContainerTabId || tab);
            }
        }, [props.active]);

        const blockConfig = props.onNormalizeBlockConfig(props);
        const hasListLayout = blockConfig.hasListLayout || (props.blockConfig && props.blockConfig.list && props.blockConfig.list.enabled);
        const hasSlideshowLayout = blockConfig.hasSlideshowLayout || (props.blockConfig && props.blockConfig.slideshow && props.blockConfig.slideshow.enabled);
        const hasThumbnailsLayout = blockConfig.hasThumbnailsLayout || (props.blockConfig && props.blockConfig.grid && props.blockConfig.grid.enabled);
        let layoutConfig;
        if (blockConfig.tabs) {
            layoutConfig = blockConfig.tabs.map((d) => {
                switch (d) {
                    case 'hasSlideshowLayout':
                        return { display: 'Slideshow', hasLayout: hasSlideshowLayout, id: Layout.Type.Result.Slideshow };
                    case 'hasThumbnailsLayout':
                        return { display: 'Grid', hasLayout: hasThumbnailsLayout, id: Layout.Type.Result.Thumbnails };
                    case 'hasPinterestLayout':
                        return { display: 'Waterfall', hasLayout: blockConfig.hasPinterestLayout, id: Layout.Type.Result.Pinterest };
                    case 'hasHorizontalMasonryLayout':
                        return { display: 'Horizontal Masonry', hasLayout: blockConfig.hasHorizontalMasonryLayout, id: Layout.Type.Result.HorizontalMasonry };
                    case 'hasListLayout':
                        return { display: 'List', hasLayout: hasListLayout, id: Layout.Type.Result.List };
                }
            })
        } else {
            layoutConfig = [
                { display: 'Slideshow', hasLayout: hasSlideshowLayout, id: Layout.Type.Result.Slideshow },
                { display: 'Grid', hasLayout: hasThumbnailsLayout, id: Layout.Type.Result.Thumbnails },
                { display: 'Waterfall', hasLayout: blockConfig.hasPinterestLayout, id: Layout.Type.Result.Pinterest },
                { display: 'Horizontal Masonry', hasLayout: blockConfig.hasHorizontalMasonryLayout, id: Layout.Type.Result.HorizontalMasonry },
                { display: 'List', hasLayout: hasListLayout, id: Layout.Type.Result.List }
            ];
        }
        if (!tab) {
            for (let i = 0; i < layoutConfig.length; i++) {
                if (layoutConfig[i].hasLayout) {
                    setTab(layoutConfig[i].id);
                    break;
                }
            }
        }
        const tabs = layoutConfig.filter(d => d.hasLayout == true);
        return (
            <WrappedComponent tab={tab || Layout.Type.Result.Thumbnails} tabs={tabs} onTabClick={handleTabClick} {...props}>
                {props.children}
            </WrappedComponent>
        );
    }
}

// #endregion LAYOUT TABS

export {
    LayoutTabs,
    LayoutTabSelectionDropDown,
    Tab,
    TabsContainer,
    TabSelectionDropDown,
    TabV2,
    withLayoutTabOptions
};